// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'
import { Col, Clearfix, Table, Button, Row, Modal } from 'react-bootstrap'
import { MainSidebar } from '../components/mainsidebar'
import config from '../config/config.json'
import { evalDateHour } from '../utils/enUtils.js'

export class Dashboard extends Component {
    constructor(props) {
        super(props)

        this.provider = this.props.appData

        this.state = {
            deleteWorker: false,
            showDeleteWorkerModal: false,
            workerToDeleteId: '',
            workerToDeleteName: '',
            workerToDeleteIndex: -1
        }

        this.handleOnClick = this.handleOnClick.bind(this)
        this.evalActivityStatus = this.evalActivityStatus.bind(this)
        this.evalRatingWorker = this.evalRatingWorker.bind(this)
        this.openDeleteWorkerModal = this.openDeleteWorkerModal.bind(this)
        this.handleDeleteWorker = this.handleDeleteWorker.bind(this)
        this.closeDeleteWorkerModal = this.closeDeleteWorkerModal.bind(this)
        this.confirmDeleteWorker = this.confirmDeleteWorker.bind(this)
        this.deleteWorkerApi = this.deleteWorkerApi.bind(this)
    }

    handleOnClick(e) {
        this.props.router.push('/addworker')
    }

    handleDeleteWorker(e) {
        e.preventDefault()

        console.log(e.target)

        this.setState({
            workerToDeleteId: e.target.getAttribute('data-id'),
            workerToDeleteName: e.target.getAttribute('data-name'),
            workerToDeleteIndex: e.target.getAttribute('data-index')
        })

        this.openDeleteWorkerModal()
    }

    deleteWorkerApi(workerId, env) {
        fetch(config[env] + config.api.disconnect_worker.endpoint + workerId, {
            method: config.api.disconnect_worker.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.provider.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.props.handleRemoveWorker(workerId)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    openDeleteWorkerModal() {
        this.setState({
            showDeleteWorkerModal: true
        })
    }

    closeDeleteWorkerModal() {
        this.setState({
            showDeleteWorkerModal: false,
            deleteWorker: false,
            workerToDeleteId: '',
            workerToDeleteName: ''
        })
    }

    confirmDeleteWorker() {

        this.deleteWorkerApi(this.state.workerToDeleteId, this.props.env)

        this.setState({
            showDeleteWorkerModal: false,
            deleteWorker: true
        })
    }

    get remainingLicenses() {
        let totalUsers = this.provider.workers.length

        return parseInt(this.provider.licenseCount, 10) - totalUsers
    }

    evalActivityStatus(last_active_at) {
        let lastActive = new Date(last_active_at)
        let today = new Date()
        let oneDay = 24 * 60 * 60 * 1000

        return ((Math.floor((today.getTime() - lastActive.getTime()) / oneDay)) > 30 ? 'Inactive' : 'Active')
    }

    evalRatingWorker(strikes, modules) {
        if (modules.length === 0)
            return ''

        switch (Math.round(strikes)) {
            case 0: return 'Excellent'
            case 1: return 'Good'
            case 2: return 'Pass'
            case 3: return 'Failed'
            default: return 'N/A'
        }
    }

    evalModulesCompleted(workerModules) {
        let completed = 0

        workerModules.forEach(module => {
            if (module.completed) {
                completed++
            }
        })

        return workerModules.length === 0 ? '' : completed + "/" + workerModules.length
    }

    get records() {
        return this.provider.workers.map((worker, index) => {
            let lastActiveDate = new Date(worker.last_active_at)

            return (
                <tr key={index}>
                    <td>
                        {worker.first_name + ' ' + worker.last_name}
                    </td>
                    <td>
                        {this.evalActivityStatus(worker.last_active_at)}
                    </td>
                    <td>
                        {evalDateHour(lastActiveDate)}
                    </td>
                    <td>
                        {this.evalModulesCompleted(worker.modules || [])}
                    </td>
                    <td>
                        {this.evalRatingWorker(worker.average_strikes, worker.modules || [])}
                    </td>
                    <td>
                        <label>
                            <Link to={{ pathname: '/dashboard/profile', query: { userId: index } }}>View</Link>
                        </label>
                        <label>
                            <Link to='/dashboard' data-index={index} data-id={worker.id} data-name={worker.first_name + ' ' + worker.last_name} onClick={this.handleDeleteWorker}>Delete</Link>
                        </label>
                    </td>
                    <Modal key={index} show={this.state.showDeleteWorkerModal} onHide={this.closeDeleteWorkerModal}  >
                        <Modal.Header>
                            <Modal.Title componentClass="h2">Confirm Deletion</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h4>Are you sure you want to reomve {this.state.workerToDeleteName} from your organisation?</h4>
                        </Modal.Body>
                        <Modal.Footer>
                            <Row>
                                <Col sm={6}>
                                    <Button bsStyle="primary" onClick={this.confirmDeleteWorker}>Confirm</Button>
                                </Col>
                                <Col sm={6}>
                                    <Button bsStyle="primary" onClick={this.closeDeleteWorkerModal}>Cancel</Button>
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </Modal>
                </tr>
            )
        })
    }

    componentWillMount() {
        if (!window.sessionStorage.getItem('authToken')) {
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            let data = {
                profileType: storedData.profileType,
                loginStatus: storedData.loginStatus,
                authToken: storedData.authToken,
                id: storedData.uid,
                admin_first_name: storedData.fname,
                admin_last_name: storedData.lname,
                name: storedData.company,
                address: storedData.address,
                license_count: storedData.licenseCount,
                globalModules: JSON.parse(storedData.globalModules)
            }

            this.props.handleProviderDataUpdateFromSessionStorage(data)
        }
        else {
            this.props.getWorkersByProvider()
        }
    }

    render() {
        this.provider = this.props.appData

        return (
            <div className="dashboard-container page-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={1}
                />
                <div className="main-body" style={{ marginLeft: "100px" }}>
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <div className="main-header">
                                <h2 className="title">Dashboard</h2>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col xsOffset={1} xs={10} smOffset={1} sm={10} mdOffset={1} md={10}>
                            <Table responsive bsClass="dashboard-data table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Status</th>
                                        <th>Last Active</th>
                                        <th>Module Completion</th>
                                        <th>Overall Results</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.records}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col xsOffset={1} xs={10} smOffset={1} sm={10} mdOffset={1} md={10}>
                            <div className="license-info">
                                <label>You have <span id="license-remaining">{this.remainingLicenses}/{this.provider.licenseCount}</span> licenses remaining</label>
                                <Button bsStyle='primary' onClick={this.handleOnClick}>Add Worker</Button>
                            </div>
                        </Col>
                    </Row>
                </div>
                <Clearfix />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/dashboard.js